export default "__VITE_ASSET__C2dXPNah__"